import { validator } from "@/utils/validator";

export const masterDataSkillTestSchema = validator.object().shape({
  skillTestName: validator.string().trim().emptyToNull().label("試験名（技能）").required(),
});
